var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiPersonOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.73047C26.1217 8.73047 28.1566 9.57332 29.6569 11.0736C31.1571 12.5739 32 14.6087 32 16.7305C32 18.8522 31.1571 20.887 29.6569 22.3873C28.1566 23.8876 26.1217 24.7305 24 24.7305C21.8783 24.7305 19.8434 23.8876 18.3431 22.3873C16.8429 20.887 16 18.8522 16 16.7305C16 14.6087 16.8429 12.5739 18.3431 11.0736C19.8434 9.57332 21.8783 8.73047 24 8.73047ZM24 12.7305C22.9391 12.7305 21.9217 13.1519 21.1716 13.902C20.4214 14.6522 20 15.6696 20 16.7305C20 17.7913 20.4214 18.8087 21.1716 19.5589C21.9217 20.309 22.9391 20.7305 24 20.7305C25.0609 20.7305 26.0783 20.309 26.8284 19.5589C27.5786 18.8087 28 17.7913 28 16.7305C28 15.6696 27.5786 14.6522 26.8284 13.902C26.0783 13.1519 25.0609 12.7305 24 12.7305ZM24 26.7305C29.34 26.7305 40 29.3905 40 34.7305V40.7305H8V34.7305C8 29.3905 18.66 26.7305 24 26.7305ZM24 30.5305C18.06 30.5305 11.8 33.4505 11.8 34.7305V36.9305H36.2V34.7305C36.2 33.4505 29.94 30.5305 24 30.5305Z",
    fill: "#04236B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiPersonOutline);
export default __webpack_public_path__ + "static/media/mdi_person-outline.936fd97332e0343983e2f33fbc99d5ec.svg";
export { ForwardRef as ReactComponent };